<script>
    import { metaInfo } from "@/core/MetaInfo";
    import BaseButton from "@main/packages/BaseButton";
    import LinkWithAnalytics from "@/components/LinkWithAnalytics";

    export default {
        name: "Wholesale",
        components: { LinkWithAnalytics, BaseButton },
        metaInfo() {
            return metaInfo.getMeta("wholesale");
        },
    };
</script>

<template>
    <div class="wholesale-page">
        <div class="l-container">
            <div class="page-title wholesale-page__title">Оптовые запросы</div>
            <div class="wholesale-page__subtitle">
                Хотите продавать Биван в своём магазине? Или заинтересовались в брендировании?
            </div>
            <base-button class="wholesale-page__link" size="lg">
                <link-with-analytics type="email" text="support@bivan.ru">
                    Написать на support@bivan.ru
                </link-with-analytics>
            </base-button>
            <div class="wholesale-page__slider"></div>
        </div>
    </div>
</template>

<style lang="scss">
    .wholesale-page {
        padding: 40px 0;
        overflow: hidden;
        @include bp($bp-desktop-sm) {
            padding: 56px 0;
        }
    }

    .wholesale-page__title {
        &.page-title {
            margin-bottom: 16px;
        }
    }

    .wholesale-page__subtitle {
        margin-bottom: 16px;
        text-align: center;
        font-size: 16px;
        line-height: 30px;
        font-weight: 400;
        a {
            color: var(--info-text);
            font-weight: 700;
        }
    }

    .wholesale-page__link {
        max-width: 330px;
        margin: 0 auto 70px;
        width: 100%;

        a {
            color: #fff;
        }

        @include bp($bp-desktop-sm) {
            margin-bottom: 45px;
        }
    }

    .wholesale-page__slider {
        width: 5000px;
        height: 180px;
        background: url("/static/bivan/assets/wholesale/bivan-repeat.jpg") 0 0 repeat-x;
        animation: bivans 50s linear infinite;
    }

    @keyframes bivans {
        0% {
            transform: translateX(0);
        }
        100% {
            transform: translateX(-2500px);
        }
    }
</style>
